import { useMemo } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { fetchProductNumbersByProductId } from "../api/productNumberService";
import { usePermissions } from "./usePermissions";
import { isPublishingStatusBlockingAssign } from "../utils/constants";
export var useCanAssignProductNumber = function (product) {
    var ky = useOkapiKy();
    var _a = usePermissions(), isAgencyWorker = _a.isAgencyWorker, isPublisher = _a.isPublisher, isProductTitleOwner = _a.isProductTitleOwner;
    var productNumbersData = useQuery(["productNumbers", product === null || product === void 0 ? void 0 : product.id], function () { return fetchProductNumbersByProductId(ky, product.id); }, {
        enabled: !!(product === null || product === void 0 ? void 0 : product.id),
    }).data;
    // Assigning a (first) ISBN/ISMN is an owner-only action for publishers: a
    // co-publisher must not assign a number to a product on someone else's title.
    var isOwner = isProductTitleOwner(product);
    var canAssignProductNumber = useMemo(function () {
        var _a, _b;
        if ((productNumbersData === null || productNumbersData === void 0 ? void 0 : productNumbersData.items) && ((_a = productNumbersData === null || productNumbersData === void 0 ? void 0 : productNumbersData.items) === null || _a === void 0 ? void 0 : _a.length) > 0)
            return false;
        // Never offer assignment for a Cancelled (01) / Postponed indefinitely (03) product.
        if (isPublishingStatusBlockingAssign((_b = product === null || product === void 0 ? void 0 : product.publishingStatus) === null || _b === void 0 ? void 0 : _b.value))
            return false;
        if (isAgencyWorker)
            return true;
        if (isPublisher)
            return isOwner;
        return false;
    }, [productNumbersData, product, isAgencyWorker, isPublisher, isOwner]);
    return { canAssignProductNumber: canAssignProductNumber, productNumbersData: productNumbersData };
};
